export const TEST_FROM_ALLOWLIST = [
  'naoresponda@adlitics.com.br',
  'suporte@adlitics.com.br',
] as const;

export type TestFromAddress = (typeof TEST_FROM_ALLOWLIST)[number];

export function isAllowedTestFrom(from: string): from is TestFromAddress {
  return (TEST_FROM_ALLOWLIST as readonly string[]).includes(from);
}

/** Canonical app origin for previews / samples (parity with Edge `APP_URL` default). */
export const DEFAULT_APP_URL = 'https://app.adlitics.com.br';

/**
 * Deep-link path segments — keep in sync with `PAGE_TO_SLUG` in `utils/routeUtils.ts`.
 * Deno mirrors the same strings in `_shared/adminComms.ts` (cannot import domain/).
 */
export const APP_DEEP_PATHS = {
  billing: 'faturamento',
  subscription: 'assinatura',
  connections: 'canais-de-atendimento',
  integrations: 'integracoes',
} as const;

export function emailLogoUrl(appUrl = DEFAULT_APP_URL): string {
  return `${appUrl.replace(/\/$/, '')}/logo%20principal%20dark%20140x40.png`;
}

export function buildSampleVars(appUrl = DEFAULT_APP_URL): Record<string, string> {
  const base = appUrl.replace(/\/$/, '');
  return {
    userName: 'Maria',
    orgName: 'Acme Ltda',
    appUrl: base,
    logoUrl: emailLogoUrl(base),
    portalLink: `${base}/${APP_DEEP_PATHS.billing}`,
    subscriptionUrl: `${base}/${APP_DEEP_PATHS.subscription}`,
    daysRemaining: '3',
    trialEndDate: '30/07/2026',
    blockedAtDate: '28/07/2026',
    instanceName: '+55 (21) 99721-2819',
    disconnectReason: 'Desconectado de outro dispositivo',
    reconnectUrl: `${base}/${APP_DEEP_PATHS.connections}`,
    integrationsUrl: `${base}/${APP_DEEP_PATHS.integrations}`,
    deletionDate: '01/10/2026',
    expiresAt: '05/08/2026',
    disconnectedAt: '23/07/2026 12:00',
  };
}
